import { Button } from "antd"
import ProjectModal from "../../../components/ProjectModal"
import { EditOutlined } from "@ant-design/icons"
import { useCallback, useMemo, useState } from "react"
import { useActions } from "../../../hooks/useActions"
import { useSearchParams } from "react-router-dom"

const EditProject: React.FC = ({}) => {
  const [isOpen, setIsOpen] = useState(false)

  const [searchParams] = useSearchParams()
  const projectId = useMemo(() => searchParams.get("projectId"), [searchParams])

  const { getProject, getProjectData, getProjectDataKeywords } = useActions()

  const refetch = useCallback(() => {
    if (!projectId) {
      return
    }

    getProject(projectId)
    getProjectData(projectId)
    getProjectDataKeywords(projectId)
  }, [projectId])

  return (
    <>
      <Button variant="solid" onClick={() => setIsOpen(true)}>
        <EditOutlined />
        Edit project
      </Button>
      <ProjectModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        refetch={refetch}
        projectId={projectId}
        isEditModal={true}
      />
    </>
  )
}

export default EditProject
